var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fillRule: "evenodd",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3,210H20.7a0.684,0.684,0,0,0-.7.664,6.334,6.334,0,0,0,2.3,4.844l3.079,2.585a2.31,2.31,0,0,1,.84,1.767v6.476a0.706,0.706,0,0,0,1.093.552l4.149-2.612a0.654,0.654,0,0,0,.313-0.552V219.86a2.31,2.31,0,0,1,.84-1.767l3.079-2.585a6.334,6.334,0,0,0,2.3-4.844A0.684,0.684,0,0,0,37.3,210Zm-2.534,4.515L31.683,217.1a3.609,3.609,0,0,0-1.312,2.76v3.508L27.629,225.1V219.86a3.609,3.609,0,0,0-1.312-2.76l-3.079-2.585a5.077,5.077,0,0,1-1.786-3.187h15.1A5.076,5.076,0,0,1,34.763,214.515Z",
    transform: "translate(-20 -210)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.d5f0b167.svg";
export { ForwardRef as ReactComponent };